import { Injectable } from '@angular/core';
import {
  DwAction,
  DwActionHandler,
  DwActionResult,
  DwActionType,
  DwGridActionResult,
  DwMetaDataGridActionState,
  DwModalButtonStandardConfigs,
  DwModalConfig,
  DwModalService,
  DwModalSize
} from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppMetaDataItemNames } from '../../../meta-data/app-meta-data.service';
import { AppPermissions } from '../../../meta-data/app-permissions.enum';
import { AddStudentByCodeModalComponent } from '../components/add-student-by-code-modal/add-student-by-code-modal.component';
import { InstructorStudentLinkResult } from '../services/instructor-repository.service';

@DwAction({
  keyName: 'instructor-add-student-by-code',
  display: 'Add Student',
  actionType: DwActionType.gridAction,
  parentItemName: AppMetaDataItemNames.DwUser,
  isGlobal: false,
  defaultButtonConfig: {
    useParentDisplay: false,
    buttonText: 'Add Student',
    iconClass: 'fa fa-user-plus',
    buttonClass: 'btn btn-primary',
    buttonTitle: 'Add a student using their training code'
  },
  defaultSecurityConfig: {
    requireAuthentication: true,
    useEmulatedPermissions: true,
    permissionMeaning: AppPermissions.studentsCanManageInstructorAssigned
  }
})
@Injectable()
export class AddStudentByCodeActionService implements DwActionHandler {
  constructor(private dwModalService: DwModalService) { }

  handleAction(actionState: DwMetaDataGridActionState<any>): Observable<DwActionResult> {
    const modalConfig = new DwModalConfig();
    modalConfig.allowFullScreen = false;
    modalConfig.modalSize = DwModalSize.medium;
    modalConfig.component = AddStudentByCodeModalComponent;
    modalConfig.title = 'Add Student';
    modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
    modalConfig.buttons[0].buttonText = 'Add Student';
    modalConfig.buttons[0].buttonClass = 'btn btn-primary';

    return this.dwModalService.showModal<any, InstructorStudentLinkResult>(modalConfig)
      .pipe(map(modalResult => {
        const result = new DwGridActionResult();

        if (modalResult.cancelled) {
          result.cancelled = true;
          result.refreshData = false;
          return result;
        }

        result.success = true;
        result.refreshData = true;
        result.message = `${modalResult.data?.StudentName || 'Student'} was added to your student list.`;
        return result;
      }));
  }
}
